import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, 
  IonLabel,
  IonAlert,
  IonLoading,
  IonRadioGroup,
  IonRadio,
  IonListHeader,
  IonButton,
  IonInput,
  IonList
  } from '@ionic/react';
  import React, {useState} from 'react';
  import './General.css';
  import ServerService from '../../../services/Server';
  import { useHistory } from 'react-router-dom';
  import { NotificationsService } from '../../../services/Notifications';
  
  const General: React.FC = () => {
  
    const name:string = "General";

    const history = useHistory();
    
    const server = new ServerService();
    server.setHistory(history);
   
    //const accounts = server.accounts;

    const [msg, setMsg] = useState("Login Successful");
    const [showMsg, setShowMsg] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    
    const [handed, setHanded] = useState(server.state.handed ? server.state.handed : "right");

    const [token, setToken] = useState("");

    const alertCallback = () => {
      window.location.reload();
    }

    // const loginCallback = (result:boolean, msg:string) => {
    //   if (msg) setMsg(msg);
    //   setShowLoading(false);
    //   setShowMsg(true);
    // }

  return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
  
        <IonContent>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle>{name}</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <IonRadioGroup value={handed} onIonChange={e => {setHanded(e.detail.value);server.state.handed=e.detail.value}}>
              <IonListHeader>
                <IonLabel>Handedness</IonLabel>
              </IonListHeader>

              <IonItem>
                <IonLabel>Left</IonLabel>
                <IonRadio slot="start" value="left" />
              </IonItem>

              <IonItem>
                <IonLabel>Right</IonLabel>
                <IonRadio slot="start" value="right" />
              </IonItem>
            </IonRadioGroup>
            <br/>

            <IonList>
              <IonItem>
                <IonInput value={token}></IonInput>
                <IonButton onClick={()=>{
                    const notiService = new NotificationsService()
                    const t = notiService.getToken()
                    t.then(value => {
                          setToken(value)
                      }).catch(reason => {
                          alert("reason:"+reason)
                      })
                  }}>Get Token</IonButton>
              </IonItem>
            </IonList>
          </IonContent>

  <IonAlert
    isOpen={showMsg}
    onDidDismiss={alertCallback}
    message={msg}
    buttons={['OK']}
  />
  <IonLoading 
    isOpen={showLoading}
    message="Please wait..."
  />
        </IonContent>
      </IonPage>
    );
  };
  
  export default General;
  